<p-tag icon="pi pi-map" iconPos="left" >
    
    <!-- <p-divider layout="vertical"></p-divider> -->
    <span [pTooltip]="formattedLocation">{{location.distance?.length | number: '1.0-2'}} {{location.distance?.units}}</span>

</p-tag> 
